import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { Tooltip } from 'src/components/Tooltip';
import { useSession } from 'src/contexts/SessionContext';
import api from 'src/utils/ajax';

interface Account {
  name: string;
  value: string;
}

interface AccountFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  disabled?: boolean;
}

export const AccountFilter: React.FC<AccountFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  disabled = false,
}) => {
  const { session } = useSession();

  const { data: accounts = [] } = useQuery({
    queryKey: ['accounts', session.id],

    queryFn: async () => {
      const response = await api.get(
        `/api/v5/platforms/${session.id}/stripe_accounts/`
      );
      return response.data;
    },

    enabled: !!session.id,
  });

  const selectedAccount = accounts.find((a) => a.value === value);

  if (valueOnly) {
    return <>{selectedAccount?.name || ''}</>;
  }

  return (
    <Tooltip title="Only revenue charged to this stripe account">
      <Autocomplete
        options={accounts}
        getOptionLabel={(option: Account) => option.name}
        value={selectedAccount || null}
        onChange={(_, newValue) => {
          setValue(newValue?.value || '');
        }}
        renderInput={(params) => (
          <TextField {...params} label={label} placeholder="Any Destination" />
        )}
        disabled={disabled}
      />
    </Tooltip>
  );
};
